module.exports = __webpack_public_path__ + "static/media/Dream_mobile_on_SE_SV.590e4a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dream_mobile_on_SE_SV.png
// module id = 554
// module chunks = 0